import { type Common } from '../common.js';
import {
  type Assistant,
  type CreateValues,
  type FindAllOptions,
  type UpdateValues,
} from '../models/assistant/assistant.js';
import {
  type AssistantDefinition,
  type PopulatedAssistantDefinition,
} from '../models/assistant/assistantDefinition/schema.js';
import { type PaginatedQueryOptions } from '../models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from '../models/pagination/PaginationResponse.type.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/assistant/assistants';
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<Assistant>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<Assistant> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async createWithDefaultDefinition(
    values: CreateValues
  ): Promise<{ assistant: Assistant; assistantDefinition: PopulatedAssistantDefinition }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/with-default-definition`);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<Assistant> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async getOneById(id: string): Promise<Assistant> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async delete(id: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }

  async getAssistantDefinitions(
    assistantId: string
  ): Promise<{ assistantDefinitions: AssistantDefinition[] }> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${assistantId}/assistant-definitions`
    );
    return await this.common.getJSON(url);
  }
}
